// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CftcCards_card__LjU2W {
  padding: 24px;
  color: var(--color-text);
}

.CftcCards_cardTitle__j2Mvf {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-text-strong);
}

.CftcCards_cardList__z2CKG {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 0.875rem;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.CftcCards_bullet__mCEKi {
  width: 6px;
  height: 6px;
  margin-top: 6px;
  border-radius: 999px;
  background: var(--color-accent);
  flex-shrink: 0;
}

.CftcCards_cardRow__FxKoJ {
  display: flex;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/cftc/CftcCards.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV","sourcesContent":[".card {\n  padding: 24px;\n  color: var(--color-text);\n}\n\n.cardTitle {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.cardList {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 0.875rem;\n  color: var(--color-text-muted);\n  line-height: 1.5;\n}\n\n.bullet {\n  width: 6px;\n  height: 6px;\n  margin-top: 6px;\n  border-radius: 999px;\n  background: var(--color-accent);\n  flex-shrink: 0;\n}\n\n.cardRow {\n  display: flex;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `CftcCards_card__LjU2W`,
	"cardTitle": `CftcCards_cardTitle__j2Mvf`,
	"cardList": `CftcCards_cardList__z2CKG`,
	"bullet": `CftcCards_bullet__mCEKi`,
	"cardRow": `CftcCards_cardRow__FxKoJ`
};
export default ___CSS_LOADER_EXPORT___;
